
const initialState = {
    data: null,
    loading: false,
    error: null,
    urls: null
}
const contentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "CONTENT_REQUEST_LOADING":
            return { ...state, loading: true };
          case "CONTENT_REQUEST_SUCCESS":
            return { ...state, loading: false, data: action.payload.data };
          case "CONTENT_REQUEST_ERROR":
            return { ...state, loading: false, error: action.payload, status: action?.status };
          case "CONTENT_EXIT":
            return {...initialState}
        default:
            return state;
    }
}
export default contentsReducer